import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
  Box,
} from "@mui/material";
import { httpclient } from "../../../utils/httpClient";

export default function RefundRejectDialog(props) {
    console.log(props.viewDetails.companyID)
  const [open, setOpen] = useState(true);
  const [reason, setReason] = useState("");
  const [reasonCode, setReasonCode] = useState("");
  const [cancelReasons, setCancelReasons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCancelReasons();
  }, []);

  const fetchCancelReasons = () => {
    setLoading(true);
    httpclient
      .get(`new-system/netsuite/order/get-cancel-reasons/${props.viewDetails.companyID}?type=refund`)
      .then(({ data }) => {
        if (data.success) {
          setCancelReasons(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error fetching cancel reasons:", err);
        setLoading(false);
      });
  };

  const handleClose = () => {
    setOpen(false);
    props.sendToRejectRefund({ open: false });
  };

  const handleRejectRefund = () => {
    if (!reason || !reasonCode) {
      return;
    }
    setOpen(false);
    props.sendToRejectRefund({ open: false, success: true }, reason, reasonCode);
  };

  const handleReasonChange = (event) => {
    const selectedReason = cancelReasons.find(
      (r) => r.code === event.target.value
    );
    if (selectedReason) {
      setReasonCode(selectedReason.code);
      setReason(selectedReason.label);
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Refund Request"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select a reason for refund request.
          </DialogContentText>
          {loading ? (
            <Box display="flex" justifyContent="center" mt={2}>
              <CircularProgress />
            </Box>
          ) : (
            <FormControl fullWidth sx={{ mt: 2, minWidth: 300 }}>
              <InputLabel id="refund-reason-label">Refund Reason</InputLabel>
              <Select
                labelId="refund-reason-label"
                id="refund-reason-select"
                value={reasonCode}
                label="Refund Reason"
                onChange={handleReasonChange}
              >
                <MenuItem value="">
                  <em>Select a reason</em>
                </MenuItem>
                {cancelReasons.map((reason) => (
                  <MenuItem key={reason.id} value={reason.code}>
                    {reason.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleRejectRefund}
            color="error"
            variant="contained"
            disabled={!reason || !reasonCode || loading}
          >
            Refund
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
